import public_heade from '@/web/public_heade.vue';
import public_bottom from '@/web/public_bottom.vue';
var object = {
  methods: {},
  computed: {},
  watch: {},
  name: 'index',
  data() {
    return {
      nors_: {},
      rs_: {},
      show_: {},
      parem_: {}
    };
  },
  // 注册子组件
  components: {
    public_heade,
    public_bottom
  }
};
export default object;